<template lang="pug">
  v-app
    Header
    v-content
      router-view
    Footer.mt-6
  //- v-row(v-scroll="onScroll")
</template>

<script>
// import WelcomePage from "./components/WelcomePage";
import Header from './components/Header';
import Footer from './components/Footer';

export default {
  name: 'App',

  components: {
    // WelcomePage,
    Header,
    Footer
  },
  data: () => ({
    drawer: null,
    offsetTop: 0
  }),
  methods: {
    // onScroll(e) {
    //   this.offsetTop = e.target.documentElement.scrollTop;
    //   if (this.offsetTop >= 150) {
    //     console.log('TCL: onScroll -> this.offsetTop', this.offsetTop);
    //   }
    // }
  }
};
</script>
<style lang="stylus">
*
  word-break normal !important

.pageTitles
  font-family Cardo, 'san-serif' !important
</style>
